import i18n from "src/translations";

/**
 * formatter for locked state cell
 * @param {string} cell the locked status
 */
export function lockedFormatter(cell) {
  return cell ? i18n.t(`data.lockedState.${cell}`) : "";
}
